.header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: #0c0f33;
}

.right-panel-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 32px;
    background-color: var(--blue-xlt);
    padding: 64px 32px;
    text-align: center;
    overflow: auto;
}

.preview-graphic {
    width: 100%;
}

.content-container {
    /* footer is 64px tall */
    height: calc(100% - 64px);
    padding-bottom: 16px;
    box-sizing: border-box;
}

.error-message {
    max-width: 400px;
    /* same as shared-styles truncate */
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
